import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import queryString from 'query-string';

import type { Bill } from 'app/redux/models/Bill/Bill';
import type { PSP } from 'app/typings/PSP';
import { apiRequest } from 'app/utils/request/api';

const path = '/admin/bills' as const;

export type GetBillsQueryParams = {
  search?: string;
  psp?: PSP[];
  sortingColumn?: string;
  sortingOrder?: string;
  offset?: number;
  limit?: number;
};

export function useGetBills(queryParams: GetBillsQueryParams = { offset: 0 }) {
  const stringifiedParams = queryString.stringify(queryParams);

  const queryKey = [path, stringifiedParams];

  return useQuery<Bill[]>({
    queryKey,
    queryFn: async () => {
      try {
        const data = await apiRequest({ path: `${path}?${stringifiedParams}` });

        return data as Bill[];
      } catch (err) {
        message.error('Error fetching bills');
        throw err;
      }
    },
    keepPreviousData: true,
  });
}
